import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import clientConfig from "../../env";
import { useSelector } from "react-redux";

const initialAttendees = [
  {
    name: "Taylor",
    img: "https://avatar.iran.liara.run/username?username=Taylor",
  },
  {
    name: "Hiren",
    img: "https://avatar.iran.liara.run/username?username=Hiren",
  },
  {
    name: "Kelly",
    img: "https://avatar.iran.liara.run/username?username=Kelly",
  },
  {
    name: "Maxinery",
    img: "https://avatar.iran.liara.run/username?username=Maxinery",
  },
  {
    name: "Jeff",
    img: "https://avatar.iran.liara.run/username?username=Jeff",
  },
];

const Attendees = (props) => {

  const { userId, firstName, profile_picture } = useSelector(
    (state) => state.user
  );
  const currentWeekEvent = useSelector(
    (state) => state.events.currentEventDetail
  );

  const [isLoading, setIsLoading] = useState(false);
  const [attendees, setAttendees] = useState([]);
  const [selectedRsvp, setSelectedRsvp] = useState(null);

  const getAttendees = async () => {
    try {
      setIsLoading(true);
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axios.get(
        `${clientConfig.siteUrl}wl/v1/attendees/${currentWeekEvent.id}/${currentWeekEvent.eventDate}/${props.userId}`,
        { headers: headers },
      );

      if(response.status === 200) {
        const attendees = response.data?.attendees.length ? response.data.attendees.filter(p => p.action_type === 'yes') : [];
        console.log("Attendees response:", response.data);
        console.log(currentWeekEvent);
        setAttendees(attendees);
        setSelectedRsvp(response.data.current_user_rsvp);
      }
    } catch(erorr) {
      console.error(erorr);
    } finally {
      setIsLoading(false);
    }
  }

  const updateEventAttendees = async (actionType, eventId) => {
    try {
      setIsLoading(true);
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axios.post(
        `${clientConfig.siteUrl}wl/v1/rsvp`,
        {
          event_id: eventId,
          event_date: `${currentWeekEvent.eventDate} ${currentWeekEvent.eventTime}`,
          user_id: userId,
          user_name: firstName,
          user_profile:
            profile_picture ||
            `https://avatar.iran.liara.run/username?username=${firstName}`,
          action_type: actionType,
        },
        { headers: headers }
      );
      return response;
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleActionClick = async (actionType, eventId) => {
    const response = await updateEventAttendees(actionType, eventId);
    if(response.status === 200) {
      const attendees = response.data?.attendees.length
        ? response.data.attendees.filter((p) => p.action_type === "yes")
        : [];
      setAttendees(attendees);
      setSelectedRsvp(response.data.current_user_rsvp);
    }
  };

  useEffect(() => {
    console.log("Fetching attendees for event:", currentWeekEvent);
    getAttendees();
  }, [props]);

  const renderAttendeesNames = () => {
    const names = attendees.map((u) => u.user_name);
    if (!names || names.length === 0) return "";
    if(names.length === 1) return `${names[0]}`;
    if (names.length === 2) return `${names[0]} and ${names[1]}`;
    if(names.length <= 5) {
      const last = names[names.length - 1];
      return `${names.slice(0, -1).join(", ")} and ${last}`;
    }
    return names
      .map((u, i) => (i < 5 ? u : null))
      .filter((u) => u)
      .join(", ");
  }

  return (
    <>
      <div className="pt-0 pb-4">
        <h4 className="font-weight-bold">RSVP</h4>

        <div className="d-flex justify-content-center rsvp-btns">
          {["yes", "no", "maybe"].map((option) => (
            <button
              key={option}
              className={`btn btn-lg ${
                selectedRsvp === option ? "active" : ""
              }`}
              onClick={() => handleActionClick(option, currentWeekEvent.id)}
              disabled={isLoading}
            >
              {option.charAt(0).toUpperCase() + option.slice(1)}
            </button>
          ))}
        </div>
      </div>

      {!attendees?.length ? (
        <div className="col-12 mb-5">
          <p className="text-center text-small">
            No one is currently attending.
          </p>
        </div>
      ) : (
        <div className="d-flex align-items-center flex-column align-content-center w-100 mb-3">
          <div className="d-flex">
            {attendees.map(
              (person, index) =>
                index < 5 && (
                  <img
                    key={index}
                    src={person.user_profile}
                    alt={person.user_name}
                    className="rounded-circle border border-dark bg-secondary"
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "cover",
                      marginLeft: index === 0 ? "0" : "-20px",
                      zIndex: 10 + index,
                    }}
                  />
                )
            )}

            {/* Circle with count + */}
            {attendees.length > 5 ? (
              <div
                className="rounded-circle text-white d-flex justify-content-center align-items-center border border-dark"
                style={{
                  width: "50px",
                  height: "50px",
                  marginLeft: "-20px",
                  fontSize: "18px",
                  zIndex: 15,
                  background: "#3762b4",
                }}
              >
                {attendees.length - 5}+
              </div>
            ) : (
              ""
            )}
          </div>

          <p className="mb-0 mt-1 ml-2">
            {renderAttendeesNames()}

            {/* {attendees
              .map((u, i) => (i < 5 ? u.user_name : null))
              .filter((u) => u)
              .join(", ")} */}
            {attendees.length > 5
              ? ` and ${attendees.length - 5} others are attending`
              : ` ${attendees.length === 1 ? "is" : "are"} attending.`}
          </p>
        </div>
      )}
    </>
  );
};

export default Attendees;
